import general from './general';

export default { ...general };
